import React from 'react'
import { Link } from 'react-router-dom'

const Dropdown = (props) => {
    const {  list, dropdownTitle } = props
    
  return (
    <>
        <div className={list.length === 0 ? "hide" : "dropdown-list-desktop"}>
            <h4 className="dropdown-title">{dropdownTitle}</h4>
            <ul className="subcontents-list-desktop">
                {list.map((j) => {
                    return (
                        <li key={j.id} id={j.id} className="subcontents-item-desktop">
                            <Link to={j.link}>
                                {j.title}
                            </Link>
                        </li>
                    )
                })}
            </ul>
        </div>
    </>
  )
}

export default Dropdown